module.exports = __webpack_public_path__ + "img/391-c8f23b.png";